import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d610fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项 目", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))
const _hoisted_5 = { style: {"margin":"38px","margin-top":"100px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 开始查询 ")

import { Dialog, Toast } from 'vant';
import Api from '@/http/api/index'

import { Ref, ref, onMounted } from 'vue';
import { useRouter } from "vue-router";
interface GovDepartmentListItem {
    appointGovDepartId: string,
    appointGovDepartName: string,
    createTime: string,
    shopId: string,
    updateTime: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const TAG = "taxDepartmentSelection";
let memberId: string = '';

const router = useRouter();


const loading = ref(false);
const onRefresh = () => {
    loadData(() => {
        setTimeout(() => {
            loading.value = false;
        }, 500);
    })
};

const currentSelectedDepartment: Ref<string> = ref('');

const show = ref(false);//遮罩层

const govListData: GovDepartmentListItem[] = []

const departmentDataList: Ref<string[]> = ref([]);
const selectedDepartment: Ref<string> = ref('');
let selectedIndex: number = 0;//default value
const onConfirm = (value: string, index: number) => {
    // Toast(`当前值: ${value}, 当前索引: ${index}`);
    // selectedDepartment.value = value
    // debugger
    currentSelectedDepartment.value = value
    selectedIndex = index;
};
const onChange = (value: string, index: number) => {
    // Toast(`当前值: ${value}, 当前索引: ${index}`);
    // selectedDepartment.value = value
};
const onCancel = () => Toast('取消');
onMounted(() => {
    loadData()
})
const loadData = (success?: () => void, fail?: () => void) => {
    let currentMemberID = router.currentRoute.value.query.memberId
    if (currentMemberID) {
        memberId = `${currentMemberID}`;
    }
    getAppointGovDepartList((dataList: GovDepartmentListItem[]) => {
        if (dataList && dataList.length > 0) {
            govListData.splice(0, govListData.length)
            govListData.push(...dataList);
            departmentDataList.value = dataList.map(item => item.appointGovDepartName)
            if (departmentDataList.value && departmentDataList.value.length > 0) {
                currentSelectedDepartment.value = departmentDataList.value[0]
            }
        }
        success && success();
    }, () => {
        fail && fail();
    })
}

const nextClick = () => {
    if (govListData.length == 0) {
        Toast('请选择项目！')
        return;
    }
    router.push({
        path: '/taxBusinessSelection',
        query: {
            memberId,
            govId: govListData[selectedIndex].appointGovDepartId
        }
    })
}

const getAppointGovDepartList = (success: (value: GovDepartmentListItem[]) => void, fail: (value: any) => void) => {
    Api.getAppointGovDepartList({
        params: {
        },
        success: (res: any) => {
            console.log('success:', res);
            if (res.code == 0) {
                success(res.data as GovDepartmentListItem[])
            } else {
                Toast('' + res.msg)
                fail('' + res.msg)
            }
        },
        fail: (value: any) => {
            Toast('' + value)
            fail('' + value)
        }
    })
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      class: "pull-refresh",
      modelValue: loading.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
      "success-text": "刷新成功",
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "department-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
        }, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(currentSelectedDepartment.value), 1),
          _createVNode(_component_van_icon, {
            name: "play",
            color: "#888"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_button, {
            class: "custom-button",
            round: "",
            block: "",
            onClick: nextClick
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_van_overlay, {
          show: show.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (show.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              title: "",
              columns: departmentDataList.value,
              onConfirm: onConfirm,
              onCancel: onCancel,
              onChange: onChange
            }, null, 8, ["columns"])
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})